import { memo } from "react"
import * as PropTypes from "prop-types"
import styled from "styled-components"
import dynamic from "next/dynamic"
import { mq } from "helpers/styled"
import { PrimaryButton } from "components/styled/Buttons/PrimaryButton"

const NoCars = dynamic(() => import("./NoCars"))
const CarItem = dynamic(() => import("./CarItem"))
// const CarPlaceholder = dynamic(() => import("./CarPlaceholder"))

const Wrapper = styled.div`
  padding: 7px 0;
  margin: 0;

  @media ${mq("lg")} {
    margin: 0 -28px;
  }
`

const List = styled.div`
  display: block;
  margin-right: calc(-1 * var(--car-spacing));
  margin-bottom: -14px;

  @media ${mq("xs")} {
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
  }

  @media ${mq("md")} {
    --car-spacing: 18px;
  }

  @media ${mq("lg")} {
    --car-spacing: 15px;

    .with-filter & {
      --car-spacing: 7px;
    }

    .preview & {
      --car-spacing: 50px;
    }
  }

  @media ${mq("xl")} {
    && {
      --car-spacing: 27px;
    }

    .with-filter & {
      --car-spacing: 20px;
    }
  }

  > * {
    margin-right: var(--car-spacing);
    margin-bottom: 14px;
    flex-grow: 1;

    @media ${mq("md")} {
      flex-grow: 0;
    }
  }
`

const LoadMoreButton =  styled(PrimaryButton)`
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s;

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`

function CarsList({ pageName, cars, show, Intro, withoutTaxes, CustomNoCars, onLoadMore, hasMore }) {
  if (!((cars || []).length)) {
    return CustomNoCars ? <CustomNoCars page={pageName} /> : <NoCars page={pageName} />
  }

  return (
    <>
      {Intro && <Intro />}
      <Wrapper>
        <List className="car-list">
          {cars.map((car, i) => (
            <CarItem key={car.id} index={i} car={car} show={show} pageName={pageName} withoutTaxes={withoutTaxes} />
          ))}
        </List>
        {hasMore && (
          <LoadMoreButton onClick={onLoadMore}>
            Cargar más coches
          </LoadMoreButton>
        )}
      </Wrapper>
    </>
  )
}

CarsList.defaultProps = {
  Intro: null,
  show: undefined,
  withoutTaxes: false,
  CustomNoCars: null,
  onLoadMore: () => {},
  hasMore: false
}

CarsList.propTypes = {
  Intro: PropTypes.func,
  cars: PropTypes.array.isRequired,
  pageName: PropTypes.string.isRequired,
  show: PropTypes.object,
  withoutTaxes: PropTypes.bool,
  CustomNoCars: PropTypes.elementType,
  onLoadMore: PropTypes.func,
  hasMore: PropTypes.bool
}

export default memo(CarsList)
